import { render, staticRenderFns } from "./PriceEditor.vue?vue&type=template&id=7515e3fb&"
import script from "./PriceEditor.vue?vue&type=script&lang=js&"
export * from "./PriceEditor.vue?vue&type=script&lang=js&"
import style0 from "./PriceEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7515e3fb')) {
      api.createRecord('7515e3fb', component.options)
    } else {
      api.reload('7515e3fb', component.options)
    }
    module.hot.accept("./PriceEditor.vue?vue&type=template&id=7515e3fb&", function () {
      api.rerender('7515e3fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PriceEditor.vue"
export default component.exports